<template>
  <router-view/>
  <LoadingModal
    v-if="isLoading"
  />
  <!-- <LoadingModal /> -->
</template>

<script>
import { defineComponent ,computed } from 'vue'
import LoadingModal from '@/components/LoadingModal.vue'
import { useStore } from 'vuex'

export default defineComponent({
  components: { LoadingModal },
  setup () {
    const store = useStore();
    const isLoading = computed(() => store.getters.getIsLoading);

    return {
      isLoading,
    }
  }
})
</script>